module.exports = __webpack_public_path__ + "img/dbzonnestraal.e2c7a009.png";